// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5337fd0b","89":"8c2e52a2","233":"ebfa6a14","288":"e980dcd3","327":"dcba0c47","445":"c7de0547","641":"89273871","673":"b0622d85","874":"1747283a"}[chunkId] + ".chunk.js";
};